import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { RoleStr } from '../Commons/Utils'

class TodoDetail extends Component {
    render() {
        // 날짜 변환
        let writeDate = ''

        const newDate = new Date(this.props.item.createdAt)
        const newYear = newDate.getFullYear()

        let newMonth = newDate.getMonth() + 1
        if (newMonth < 10) {
            newMonth = '0' + newMonth
        }
        let newDay = newDate.getDate()
        if (newDay < 10) {
            newDay = '0' + newDay
        }

        writeDate = `${newYear}.${newMonth}.${newDay}`

        let status = ''
        if (this.props.item.status === 'READY') {
            status = 'status_b'
        } else if (this.props.item.status === 'HOLD') {
            status = 'status_r'
        } else if (this.props.item.status === 'OPEN') {
            status = 'status_y'
        } else {
            status = 'status_g'
        }

        return (
            <Link to={`/todo/${this.props.item._id}`}>
                <ul className="todo_item">
                    <li className="title">
                        <p className="title_text">{this.props.item.title}</p>
                        <p className="reply_length">[{this.props.item.comments.length}]</p>
                    </li>
                    <li className="name pc_v_impo">{this.props.item.writer.name}</li>

                    <li className="date">
                        {writeDate}
                        <span className={status + ' status mobile_v'}>{this.props.item.status}</span>
                    </li>
                    <li className={status + ' status pc_v_impo'}>{this.props.item.status}</li>
                </ul>
            </Link>
        )
    }
}

export default TodoDetail



// WEBPACK FOOTER //
// ./Src/Components/Todo/TodoItem2.js